document.addEventListener("DOMContentLoaded", function () {
  const menuSummaries = document.querySelectorAll('.header__inline-menu summary');
  const panels = document.querySelectorAll('.menu-tabs-wrapper .menu-tabs');

  function showPanel(panelName) {
    panels.forEach(panel => {
      if (panel.dataset.panel === panelName) {
        panel.style.display = 'flex';
      } else {
        panel.style.display = 'none';
      }
    });
  }

  const activeMenuItem = document.querySelector('.header__active-menu-item');
  if (activeMenuItem) {
    const activeSummary = activeMenuItem.closest('summary');
    if (activeSummary) {
      activeSummary.parentElement.open = true;
      activeSummary.setAttribute('aria-expanded', 'true');
      const panelName = activeSummary.id.replace('HeaderMenu-', '');
      showPanel(panelName);
    }
  } else {
    const firstSummary = menuSummaries[0];
    if (firstSummary) {
      const firstPanel = firstSummary.id.replace('HeaderMenu-', '');
      firstSummary.parentElement.open = true;
      firstSummary.setAttribute('aria-expanded', 'true');
      showPanel(firstPanel);
    }
  }
  menuSummaries.forEach(summary => {
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      menuSummaries.forEach(s => {
        if (s !== summary) {
          s.parentElement.open = false;
          s.setAttribute('aria-expanded', 'false');
        }
      });

      const isOpen = summary.parentElement.hasAttribute('open');
      summary.parentElement.open = !isOpen;
      summary.setAttribute('aria-expanded', String(!isOpen));

      const panelName = summary.id.replace('HeaderMenu-', '');
      showPanel(panelName);
    });
  });
});

function initBannerSwiper() {
  const isDesktop = window.innerWidth >= 767; // breakpoint

  return new Swiper('.banner-swiper', {
    loop: true,
    effect: isDesktop ? 'fade' : 'slide',
    fadeEffect: isDesktop ? { crossFade: true } : {},

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

// Initialize on page load
let bannerSwiper = initBannerSwiper();

// Re-init on resize if effect needs to change
window.addEventListener('resize', () => {
  const newIsDesktop = window.innerWidth >= 767;
  const currentEffect = bannerSwiper.params.effect;
  const desiredEffect = newIsDesktop ? 'fade' : 'slide';

  if (currentEffect !== desiredEffect) {
    bannerSwiper.destroy(true, true);
    bannerSwiper = initBannerSwiper();
  }
});


let SwiperTop = new Swiper('.swiper--top', {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 6000,
  autoplay: {
    delay: 1,
  },
  loop: true,
  slidesPerView:'auto',
  allowTouchMove: false,
  disableOnInteraction: true
});


document.querySelectorAll('.footer-block__heading').forEach(heading => {
  heading.addEventListener('click', () => {
    const parentBlock = heading.closest('.footer-block');
    if (parentBlock) {
      parentBlock.classList.toggle('active');
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  // Open all <details> tags inside #FacetFiltersForm
  document.querySelectorAll('#FacetFiltersForm details').forEach(detail => {
    detail.open = true;
  });

  // Click all "show more" buttons
  document.querySelectorAll('show-more-button .button-show-more').forEach(button => {
    button.click();
  });
});

const thumbs = new Swiper('.gallery-thumbs', {
  slidesPerView: "auto",
  spaceBetween: 24,
  slideToClickedSlide: true,
  watchSlidesProgress: true, // Required for syncing
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    dynamicMainBullets: 3,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1440: {
      slidesPerView: 6,
      spaceBetween: 24
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 20
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 16
    }
  }
});

// 2. Then initialize the main slider and link thumbs
const slider = new Swiper('.gallery-slider', {
  slidesPerView: 1,
  centeredSlides: true,
  thumbs: {
    swiper: thumbs
  }
});

var eventswiper = new Swiper(".eventSwiper", {
  slidesPerView: "auto",
  spaceBetween: 32,
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});


  window.addEventListener("scroll", function () {
    if (window.scrollY > 10) {
      document.body.classList.add("scrolled");
    } else {
      document.body.classList.remove("scrolled");
    }
  });

document.querySelectorAll('.third-level-toggle').forEach(button => {
  button.addEventListener('click', () => {
    const dropdown = button.nextElementSibling;
    const isOpen = dropdown.classList.contains('hidden');
    
    dropdown.classList.toggle('hidden');
    button.setAttribute('aria-expanded', isOpen);
  });
});

const accordion = document.querySelector(".product__accordion");
    const content = accordion?.querySelector(".accordion__content");

    // Trim whitespace and check if it's empty
    if (content && content.innerHTML.trim() === "") {
      accordion.style.display = "none";
    }


    document.addEventListener("DOMContentLoaded", function () {
  const filterWrapper = document.querySelector(".custom-collection-filters");
  if (!filterWrapper) return; // exit if wrapper not found

  const showMoreBtn = filterWrapper.querySelector(
    ".collection-list-show-more-button"
  );
  if (!showMoreBtn) return;

  const list = filterWrapper.querySelector("#collections-list");
  const hiddenItems = list.querySelectorAll(".custom-hide");
  const labelShowMore = showMoreBtn.querySelector(".label-show-more");
  const labelShowLess = showMoreBtn.querySelector(".label-show-less");

  showMoreBtn.addEventListener("click", function (e) {
    e.preventDefault(); // stop any default action

    const isExpanded = !hiddenItems[0].classList.contains("custom-hide");

    if (isExpanded) {
      // Hide extra items
      hiddenItems.forEach((item) => item.classList.add("custom-hide"));
      labelShowMore.classList.remove("hidden");
      labelShowLess.classList.add("hidden");
    } else {
      // Show extra items
      hiddenItems.forEach((item) => item.classList.remove("custom-hide"));
      labelShowMore.classList.add("hidden");
      labelShowLess.classList.remove("hidden");
    }
  });
});




// document.addEventListener("DOMContentLoaded", function () {
//   const menuSummaries = document.querySelectorAll('.header__inline-menu summary');
//   const panels = document.querySelectorAll('.menu-tabs-wrapper .menu-tabs');

//   // Function to show the right panel
//   function showPanel(panelName) {
//     panels.forEach(panel => {
//       if (panel.dataset.panel === panelName) {
//         panel.style.display = 'flex';
//       } else {
//         panel.style.display = 'none';
//       }
//     });
//   }

//   // Default: open first menu
//   const firstSummary = menuSummaries[0];
//   if (firstSummary) {
//     const firstPanel = firstSummary.id.replace('HeaderMenu-', '');
//     firstSummary.parentElement.open = true;
//     firstSummary.setAttribute('aria-expanded', 'true');
//     showPanel(firstPanel);
//   }

//   // Click / toggle listener
//   menuSummaries.forEach(summary => {
//     summary.addEventListener('click', function (e) {
//       e.preventDefault();

//       // Close all other details
//       menuSummaries.forEach(s => {
//         if (s !== summary) {
//           s.parentElement.open = false;
//           s.setAttribute('aria-expanded', 'false');
//         }
//       });

//       // Toggle current one
//       const isOpen = summary.parentElement.hasAttribute('open');
//       summary.parentElement.open = !isOpen;
//       summary.setAttribute('aria-expanded', String(!isOpen));

//       // Show corresponding panel
//       const panelName = summary.id.replace('HeaderMenu-', '');
//       showPanel(panelName);
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", () => {
  const variantForm = document.querySelector('form[data-product-form]'); // adjust to your product form selector
  if (!variantForm) return;

  let scrollX, scrollY;
  let scrollTimeout;

  // Function to restore scroll
  function restoreScroll() {
    window.scrollTo(scrollX, scrollY);
  }

  variantForm.addEventListener("change", (e) => {
    // Save scroll position immediately
    scrollX = window.scrollX;
    scrollY = window.scrollY;

    // Clear any previous restoration timers
    if (scrollTimeout) clearInterval(scrollTimeout);

    // Repeatedly restore scroll for a short period (to catch delayed DOM changes)
    scrollTimeout = setInterval(() => {
      restoreScroll();
    }, 10);

    // Stop after 1-2 seconds (long enough to cover async updates)
    setTimeout(() => {
      clearInterval(scrollTimeout);
    }, 2000); // adjust if needed
  });
});


// function matchPrices() {
//   const working = document.querySelector('.working-price');
//   const custom = document.querySelector('.custom-price');
//   const customtwo = document.querySelector('.custom-price-two');

//   if (working && custom) {
//     const workingValue = working.innerHTML.trim();
//     const customValue = custom.innerHTML.trim();

//     // If not matching → update custom-price
//     if (workingValue !== customValue) {
//       custom.innerHTML = workingValue;
//       customtwo.innerHTML = workingValue;
//       console.log("Custom price updated to match working price:", workingValue);
//     }
//   }
// }

// // Run immediately
// matchPrices();

// // Run on any DOM changes (Shopify variant changes, AJAX, etc.)
// const observer = new MutationObserver(() => matchPrices());
// observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener("click", function (e) {
  const link = e.target.closest("#colorbody .colorrow a");

  // ❌ Skip if no link OR if it's .back-to-top
  if (!link || link.classList.contains("back-to-top")) return;

  e.preventDefault();
  e.stopPropagation();

  const heading = link.querySelector("h2");
  if (!heading) return;

  let text = heading.innerText;

  // 🔥 FIX: remove line breaks + extra spaces
  text = text.replace(/\n/g, " ").replace(/\s+/g, " ").trim();

  console.log("Clean text:", text);

  // Shopify encoding
  let encoded = encodeURIComponent(text).replace(/%20/g, "+");

  const url = `/collections/all?sort_by=title-ascending&filter.v.option.color=${encoded}`;

  console.log("Final URL:", url);

  window.location.href = url;
});


(function () {
  let lastUrl = location.href;

  const observer = new MutationObserver(() => {
    const currentUrl = location.href;

    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;

      scrollToGrid();
    }
  });

  observer.observe(document, { subtree: true, childList: true });

  function scrollToGrid() {
    const el = document.querySelector('#ProductGridContainer');
    if (el) {
      el.scrollIntoView({
        behavior: 'auto', // instant
        block: 'start'
      });
    }
  }
})();




document.addEventListener('DOMContentLoaded', function () {

  function initCollectionFilterSearch() {
    const inputs = document.querySelectorAll('.collection-search-input');

    inputs.forEach((input, index) => {

      // 🚫 Prevent duplicate initialization
      if (input.dataset.initialized) return;
      input.dataset.initialized = "true";

      // ✅ Unique key per filter
      const parent = input.closest('[data-index]');
      const key = 'filterSearch-' + (parent ? parent.dataset.index : index);

      // ✅ Restore saved value
      const savedValue = sessionStorage.getItem(key) || '';
      input.value = savedValue;

      // 🚫 Block Shopify default behavior
      input.addEventListener('input', function (e) {
        e.stopPropagation();
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
        }
      });

      // ✅ Filtering logic
      input.addEventListener('input', function () {
        const searchValue = this.value.toLowerCase().trim();

        // Save value
        sessionStorage.setItem(key, searchValue);

        const container = this.closest('.facets__display, .facets__display-vertical');
        if (!container) return;

        // ✅ Create "no result" message
        let noResultMsg = container.querySelector('.filter-no-result');

        if (!noResultMsg) {
          noResultMsg = document.createElement('div');
          noResultMsg.className = 'filter-no-result';
          noResultMsg.textContent = 'Color not found';
          noResultMsg.style.display = 'none';
          noResultMsg.style.padding = '10px 0';
          noResultMsg.style.fontSize = '14px';
          noResultMsg.style.opacity = '0.7';

          container.appendChild(noResultMsg);
        }

        const groups = container.querySelectorAll('.color-group-accordion');

        let totalVisible = 0;

        groups.forEach(group => {
          const items = group.querySelectorAll('.facets__item');

          let visibleCount = 0;

          items.forEach((item) => {
            const text = item.textContent.toLowerCase();
            const match = text.includes(searchValue);

            if (searchValue === '' || match) {
              item.style.display = '';
              visibleCount++;
              totalVisible++;
            } else {
              item.style.display = 'none';
            }
          });

          if (visibleCount === 0) {
            group.style.display = 'none';
          } else {
            group.style.display = '';

            if (searchValue !== '') {
              group.open = true;
            }
          }
        });

        // ============================
        // ✅ NEW: Disabled check logic
        // ============================

        const allItems = container.querySelectorAll('.facets__item');

        let allDisabled = true;
        let hasVisibleItems = false;

        allItems.forEach(item => {
          if (item.style.display !== 'none') {
            hasVisibleItems = true;

            if (!item.classList.contains('disabled')) {
              allDisabled = false;
            }
          }
        });

        // 🔥 Find show-more-button
        let showMoreWrapper = noResultMsg.previousElementSibling;
        const isShowMore =
          showMoreWrapper &&
          showMoreWrapper.tagName.toLowerCase() === 'show-more-button';

        // ============================
        // ✅ FINAL TOGGLE
        // ============================

        if (
          searchValue !== '' &&
          (totalVisible === 0 || (hasVisibleItems && allDisabled))
        ) {
          noResultMsg.style.display = 'block';

          if (isShowMore) {
            showMoreWrapper.style.display = 'none';
          }

        } else {
          noResultMsg.style.display = 'none';

          if (isShowMore) {
            showMoreWrapper.style.display = '';
          }
        }

      });

      // ✅ Apply filter on load
      if (savedValue !== '') {
        input.dispatchEvent(new Event('input'));
      }
    });
  }

  // 🔥 Initial run
  initCollectionFilterSearch();

  // 🔥 Observe Shopify AJAX updates
  const target = document.querySelector('#ProductGridContainer') || document.body;

  const observer = new MutationObserver(() => {
    initCollectionFilterSearch();
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });

});